<style scoped>

</style>
<template>
  <div>
  <v-toolbar :color="chart.chartData.theme" prominent tabs>
    <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
    <v-toolbar-title class="title mr-4"> {{ chart.parameters.title.value }} </v-toolbar-title>
    <v-autocomplete
      v-model="model"
      :items="chart.chartData.series"
      loading="false"
      chips
      clearable
      hide-details
      hide-selected
      item-text="name"
      item-value="symbol"
      :label="chart.parameters.searchPlaceholder.value"
      solo
    >
      <template v-slot:no-data>
        <v-list-tile>
          <v-list-tile-title>
          {{ chart.parameters.searchPlaceholder.value }}
          </v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-slot:selection="{ item, selected }">
        <v-chip
          :selected="selected"
          color="blue-grey"
          class="white--text"
        >
          <v-icon left>mdi-coin</v-icon>
          <span v-text="item.name"></span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <!--
        <v-list-tile-avatar
          color="indigo"
          class="headline font-weight-light white--text"

        >
          {{ item.name.charAt(0) }}
        </v-list-tile-avatar>
      -->
        <v-list-tile-content>
          <v-list-tile-title v-text="item.name"></v-list-tile-title>
          <v-list-tile-sub-title v-text="item.symbol"></v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon>mdi-coin</v-icon>
        </v-list-tile-action>
      </template>
    </v-autocomplete>
    <template v-slot:extension>
      <v-tabs
        :hide-slider="!model"
        color="transparent"
        slider-color="blue-grey"
        v-if="chart.chartData.series.length"
      >
        <v-tab :disabled="!model" :key="index" v-for="(item, index) in chart.chartData.series[0].data"> {{ item.x }}</v-tab>
      </v-tabs>
    </template>
  </v-toolbar>
</div>
</template>
<script>
export default {
    props:['chart'],
    data: function() {
      return {
        model: false,
      };
    },
    methods: {

    },
    computed: {

    },
    components: {

    },
    mounted: function() {
      console.log(this);
    }
}

</script>
